<template>
  <notification-wrapper>
    <authentication-wrapper>
      <router-view />
      <PaymentRealtimeNotificationStackWrapper />
    </authentication-wrapper>
  </notification-wrapper>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import Mitt from "mitt";

import NotificationWrapper from "@/core/components/NotificationWrapper.vue";
import AuthenticationWrapper from "./modules/Auth/components/AuthenticationWrapper.vue";
import PaymentRealtimeNotificationStackWrapper from "./modules/Payments/components/PaymentRealtimeNotificationStackWrapper.vue";

import { AUTH_EVENTS } from "@/core/eventBusses/auth";
import { NOTIFICATION_EVENTS } from "@/core/eventBusses/notification";
import { setThemeColor } from "@/core/utils/colortheme";
import { AGENT_FINANCES_EVENTS } from "@/core/eventBusses/agentFinances";
import storageService from "./core/services/storage.service";
import { Organization } from "./modules/Auth/types";
import { STORAGE_KEYS } from "./core/constants/storageKeys";

// beforeCreate equivalent - runs before component instance is created
const organization = storageService.getItem<Organization>(
  STORAGE_KEYS.ORGANIZATION,
);

setThemeColor(organization);

// Methods
const setFaviconUrls = (): void => {
  const faviconUrl: string | undefined = import.meta.env
    .VITE_APP_DEFAULT_FAVICON;

  if (faviconUrl) {
    (document.getElementById("favicon") as HTMLLinkElement).href = faviconUrl;
    (document.getElementById("favicon-small") as HTMLLinkElement).href =
      faviconUrl;
    (document.getElementById("apple-touch-icon") as HTMLLinkElement).href =
      faviconUrl;
  }
};

// created equivalent
onMounted(() => {
  setFaviconUrls();
});

// beforeUnmount equivalent
onBeforeUnmount(() => {
  const mitt = Mitt();

  mitt.off(NOTIFICATION_EVENTS.TRIGGER);
  mitt.off(AUTH_EVENTS.LOGIN);
  mitt.off(AUTH_EVENTS.LOGOUT);
  mitt.off(AGENT_FINANCES_EVENTS.REFRESH);
});
</script>

<style lang="css"></style>
